import React from 'react';
import { Field, Spinner, Modal } from '../Common';
import readFile from '../../utils/readFile';
import { download } from '../../api/api';

export default class OtherProvision extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            animalsCharged: '',
            name: this.props.data != null && this.props.data.responsibleAnimal != null &&  this.props.data.responsibleAnimal.nom != null? this.props.data.responsibleAnimal.nom : '',
            firstName: this.props.data != null && this.props.data.responsibleAnimal != null && this.props.data.responsibleAnimal.prenom != null? this.props.data.responsibleAnimal.prenom : '',
            email: this.props.data != null && this.props.data.responsibleAnimal != null && this.props.data.responsibleAnimal.email != null ? this.props.data.responsibleAnimal.email : '',
            administrativeProceduresCharged: '',
            ceremonieVisuelTitre: this.props.data
                && this.props.data.ceremonieVisuelTitre
                ? this.props.data.responsibleAnimal.ceremonieVisuelTitre : '',
            files: [],
            showDelete: false,
            upload: false,
            error: {
                files: ''
            },
            displayModal: 'inactive',
            videoSpinner: 'inactive',
        }
    }

    componentDidMount() {
        if ( this.props.data
            && this.props.data.ceremonieVisuelTitre ) {
                let file = { name: this.props.data.ceremonieVisuelTitre.filename };
                this.state.files.push(file);
                this.setState({ showDelete: true, files: this.state.files });
            }
    }

    handleOnChange = (key, e) => {
        const value = e.target.value;
        this.setState(() => ({ [key]: value }));
    }

    handleFileChange = (e) => {
        const files = e.target.files;
        const fileSize = files[0] && files[0].size / 1024 / 1024;
        if (fileSize > 4.5 * 1024) {
            this.setState(prevState => ({
                files: [],
                error: {
                    ...prevState.error,
                    files: ' La taille du fichier ne doit pas dépasser 5 Gb'
                }
            }))
        } else
            if (files[0] && this.validFile(files[0].name)) {
                this.setState(prevState => ({
                    files,
                    showDelete: true,
                    upload: true,
                    error: {
                        ...prevState.error,
                        files: ''
                    }
                }))
            } else {
                this.setState(prevState => ({
                    files: [],
                    error: {
                        ...prevState.error,
                        files: ' Merci de choisir un fichier de cette liste [ mp4, mov, mkv, jpg, png ]'
                    }
                }))
            }
    }

    validFile = name => {
        const list = ['mp4', 'mov', 'mkv', 'jpg', 'png'];
        if (name) {
            const s = name.toLowerCase().split('.')[name.split('.').length - 1];
            if (list.indexOf(s) > -1)
                return true
        }
        return false
    }


    playVideo = (videoName, action) => {
        if (action == 'video') {
            this.setState({ displayModal: 'active' });
            window.scrollTo(0, 0);
        } else {
            this.setState({ videoSpinner: 'active' });
        }
        const data = {
            'file': `${this.props.idBeneficiaire}/${videoName}`
        }
        download(data, this.props.idPartenaire).then(data => {
            readFile(data.response, videoName, data.type, action);
            this.setState({ videoSpinner: 'inactive' });
        }, error => {
            // handle errors
        });
    }

    closeModal = () => {
        this.setState({ displayModal: 'inactive' });
    }

    actionType = fileName => {
        const ext = fileName.split('.')[fileName.split('.').length - 1];
        const images = ['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG'];
        if (images.indexOf(ext) > -1)
            return 'download';
        return 'video';
    }


    onSubmit = (e) => {
        e.preventDefault();

        let files = this.state.files;
        if ( !this.state.upload ) {
            files = [];
        }

        let file = '';
        if (files.length > 0) {
            file = new FormData();
            file.append('file', this.uploadInput.files[0]);
            file.append('fileType', 'VISUAL_CEREMONY');
            file.append('idBeneficiaire', this.props.idBeneficiaire);
        }
        let autres = {
            responsibleAnimal: {
                prenom: this.state.firstName,
                nom: this.state.name,
                email: this.state.email,
                ceremonieVisuelTitre: files[0] && files[0].name,
            },
            file
        }
        if (autres.ceremonieVisuelTitre != null && autres.ceremonieVisuelTitre.name) {
            autres.ceremonieVisuelTitre.filename = this.state.file.name;
        }
        this.props.onOtherProvisionSubmit(autres);
    }

    deleteFile = (fileName) => {
        this.setState(() => ({ files: [], showDelete: false } ));

        let file = new FormData();
        file.append('fileName', fileName);
        file.append('fileType', 'VISUAL_CEREMONY');
        file.append('idBeneficiaire', this.props.idBeneficiaire);
        this.props.deleteFile(file);
    }

    render() {
        const divStyle = {
			display: 'inline-flex'
		};
        return (
            <div>
                <Modal status={this.state.displayModal}>
                    <div onClick={this.closeModal} className="close">X</div>
                    <video poster="/images/video-loader.gif" preload="auto" controls autoPlay ></video>
                </Modal>
                <form onSubmit={this.onSubmit} className="funeral-form" encType="multipart/form-data">
                    <div className="row">
                        <div className="col-sm-5">
                            <img src='/images/od-2-lg.png' alt="image profil" className=" _lg" />
                            <img src='/images/od-2-sm.png' alt="image profil" className="_sm" />
                        </div>
                        <div className="col-sm-7 form-container top-from padding-left file-label">
                            <label>Aprés la cérémonie, je souhaite que cette vidéo ou cette image soit diffusée :</label>
                            <div className="tooltip-toggle btn-info-tooltip"
                                aria-label="Merci de choisir un fichier de cette liste [ 'mp4', 'mov', 'mkv', 'jpg', 'png' ]"
                                tabIndex="0"
                            >
                            </div>
                            {this.props.data
                                && this.props.data.ceremonieVisuelTitre
                                && this.props.data.ceremonieVisuelTitre.filename 
                                && this.state.showDelete
                                &&
                                <div>
                                    {(this.actionType(this.props.data.ceremonieVisuelTitre.filename) === "video")
                                        ?
                                        <div style={divStyle}>
                                            <div className="video-container">
                                                <div className="div-link" onClick={() => this.playVideo(this.props.data.ceremonieVisuelTitre.filename, 'video')}>
                                                    Lire la vidéo sauvegardée
                                                </div>
                                                <a className="round-btn btn-download" onClick={() => this.playVideo(this.props.data.ceremonieVisuelTitre.filename, 'download')}>
                                                    <img src="/images/download-icon.png" width="13" height="15" />
                                                </a>
                                                <Spinner status={this.state.videoSpinner} />
                                            </div>
                                            <div className="div-link text-link" onClick={() => this.deleteFile(this.props.data.ceremonieVisuelTitre && this.props.data.ceremonieVisuelTitre.filename)}>
                                                Supprimer
                                            </div>
                                        </div>
                                        :
                                        <div style={divStyle}>
                                            <div className="div-link" onClick={() => this.playVideo(this.props.data.ceremonieVisuelTitre.filename, 'download')}>
                                                Télécharger l'image sauvegardée
                                            </div>
                                            <div className="div-link text-link" onClick={() => this.deleteFile(this.props.data.ceremonieVisuelTitre && this.props.data.ceremonieVisuelTitre.filename)}>
                                                Supprimer
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            <div className="custom-file full-width">
                                <input
                                    type="file"
                                    className={this.state.error.files ? "custom-file-input is-invalid" : "custom-file-input"}
                                    id="customFile"
                                    ref={(ref) => { this.uploadInput = ref; }}
                                    onChange={this.handleFileChange}
                                />

                                <label className={"custom-file-label " + this.props.spinner} htmlFor="customFile" data-browse="">
                                    <div>
                                        {this.props.spinner === 'active' ? 'Chargement en cours ...' : this.state.files[0] && this.state.files[0].name}
                                    </div>
                                </label>
                                {this.state.error.files &&
                                    <div className="invalid-feedback error-files">
                                        {this.state.error.files}
                                </div>
                                }
                                <Spinner status={this.props.spinner} />
                            </div>
                            <div className="margin-top">
                                <label>Je souhaite que mon animal ou mes animaux de compagnie soient pris en charge par </label>
                                <Field
                                    label="Nom "
                                    type="text"
                                    ////placeholder="DUPOND"
                                    _className={"form-control address "}
                                    value={this.state.name}
                                    onChange={this.handleOnChange.bind(this, "name")}

                                />
                                <Field
                                    label="Prénom "
                                    type="text"
                                    ////placeholder="ALAIN"
                                    _className={"form-control address "}
                                    value={this.state.firstName}
                                    onChange={this.handleOnChange.bind(this, "firstName")}

                                />
                                <Field
                                    label="Email "
                                    type="email"
                                    ////placeholder="ALAIN"
                                    _className={"form-control  address"}
                                    value={this.state.email}
                                    onChange={this.handleOnChange.bind(this, "email")}

                                />
                            </div>
                            <h5>Vous devrez informer cette personne de sa mission</h5>
                            <div className="required-txt"> * Champs obligatoires</div>
                        </div>
                        <div className="col-sm-12 form-container align-center">
                            <div className="button-container">
                                <button className="btn btn-outline-primary" onClick={this.props.back}>Precedent</button>
                                <button type="submit" className="btn btn-primary">Enregistrer</button>
                            </div>
                        </div>
                    </div>
                </form >
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FuneralPage/OtherProvisionForm.js